/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { AutoComplete, Form } from "antd";
import { useRef } from "react";

function AutoCompleteAddress({
  // addressDetailsCallback,
  form,
  fieldName,
  className = null,
  label,
  disabledFeilds = false,
  returnAddress = false,

  setUseGoogleAddr = () => {},
  handleTabEnter,
  resetForm,
  disabled,
  required = true,
}) {
  const [addressOptions, setAddressOptions] = useState([]);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const currentEnv = process.env.REACT_APP_ENV;

  useEffect(() => {
    if (resetForm) {
      setAddressOptions([]);
    }
  }, [resetForm]);

  useEffect(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      setIsApiLoaded(true);
    } else {
      const checkGoogleApi = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
          setIsApiLoaded(true);
          clearInterval(checkGoogleApi);
        }
      }, 100);
    }
  }, []);

  const debounceTimeout = useRef(null);

  const handleSearchDebounce = (e) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    if (e?.code === "Enter") {
      onEnter(e);
      return;
    }

    if (e?.code === "Tab") {
      // onEnter(e);
      handleKeyDown(e);
      return;
    }

    debounceTimeout.current = setTimeout(async () => {
      handleSearch(e);
    }, 400);
  };

  const handleSearch = (data) => {
    let value = data?.target?.value || "";

    if (!value || !isApiLoaded) {
      setAddressOptions([]);
      setUseGoogleAddr(false);
      return;
    }

    if (value?.length > 4) {
      const allowedPincode = form.getFieldValue("deliveryPincode"); // Fetching pincode
      if (!allowedPincode) {
        return;
      }
      const autocompleteService =
        new window.google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions(
        { input: value, componentRestrictions: { country: "IN" } },
        (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            if (allowedPincode) {
              setAddressOptions(
                predictions?.map((item, idx) => ({
                  value: item?.description?.toUpperCase(),
                  label: item?.description?.toUpperCase(),
                  key: item?.place_id || idx,
                }))
              );
            }
          } else {
            // form.setFieldValue([fieldName], value);
            setAddressOptions([]);
          }
        }
      );
    }
  };

  const onSelect = (value, selectedObj) => {
    // form.setFieldValue([fieldName], value);
    // fetchPlaceDetails(selectedObj?.key);
    setUseGoogleAddr(true);
    // onEnter(null, "mobileNumber");
  };

  // const fetchPlaceDetails = (placeId) => {
  //   const map = new window.google.maps.Map(document.createElement("div"));
  //   const service = new window.google.maps.places.PlacesService(map);

  //   service.getDetails(
  //     {
  //       placeId: placeId,
  //       fields: ["address_component", "geometry", "formatted_address", "name"],
  //     },
  //     (place, status) => {
  //       if (status === window.google.maps.places.PlacesServiceStatus.OK) {
  //         const details = place?.address_components?.reduce(
  //           (acc, component) => {
  //             const typeToKey = {
  //               postal_code: "zip",
  //               subpremise: "house_flat_Num",
  //               administrative_area_level_3: "city",
  //               administrative_area_level_1: "state",
  //               country: "country",
  //               route: "route",
  //               landmark: "landmark",
  //             };
  //             component.types.forEach((type) => {
  //               if (typeToKey[type]) {
  //                 acc[typeToKey[type]] = component?.long_name;
  //               }
  //             });
  //             return acc;
  //           },
  //           {}
  //         );
  //         if (place?.geometry && place?.geometry?.location) {
  //           details.latitude = place?.geometry?.location?.lat();
  //           details.longitude = place?.geometry?.location?.lng();
  //         }
  //         if (place.formatted_address) {
  //           details.completeAddress = place?.formatted_address;
  //         }
  //         // addressDetailsCallback(details);
  //       }
  //     }
  //   );
  // };

  // const onChange = (value) => {
  //   form.setFieldValue([fieldName], value);
  // };

  const resetActiveState = () => {
    document.querySelectorAll(".ant-select-item-option")?.forEach((option) => {
      option.classList.remove("ant-select-item-option-active");
    });
  };

  const handleKeyDown = (event) => {
    let activeOption = document.querySelector(".ant-select-item-option-active");

    if (activeOption) {
      const value = activeOption.getAttribute("title");
      if (value) {
        form.setFieldsValue({
          [fieldName]: value,
        });
      }
    }
  };

  function onEnter(event) {
    event?.preventDefault();

    if (!event.target?.value?.trim()) {
      form.setFields([
        {
          name: fieldName,
          errors: ["Enter address"],
        },
      ]);
      return;
    }

    const tabbableElements = Array.from(
      document.querySelectorAll("input, button, select, textarea, a[href]")
    )?.filter((el) => !el?.disabled && el?.offsetParent !== null);

    const currentIndex = tabbableElements?.indexOf(document?.activeElement);

    const nextIndex = (currentIndex + 1) % tabbableElements?.length;

    tabbableElements[nextIndex]?.focus();
    tabbableElements[nextIndex]?.select();

    // handleTabEnter(event);
  }

  return (
    <Form.Item
      label={label}
      name={fieldName}
      rules={[
        {
          required: required,
          message: "Enter address",
        },
      ]}
    >
      <AutoComplete
        showSearch
        // onBlur={() => {
        //   resetActiveState();
        //   setAddressOptions([]);
        // }}
        disabled={disabledFeilds}
        onFocus={() => {
          resetActiveState();
        }}
        className={className}
        popupClassName="custom-auto-complete"
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            onEnter(event);
          }
        }}
        options={addressOptions || []}
        onKeyDown={(e) => {
          // if (e.key == "Tab") {
          //   onEnter(e);
          // }
          // handleSearchDebounce(e); // Trigger debounce on key down
        }}
        onInput={(e) => {
          const input = e?.target;
          const cursorPosition = input?.selectionStart;
          const upperCaseValue = input?.value?.toUpperCase();
          input.value = upperCaseValue;

          input.setSelectionRange(cursorPosition, cursorPosition);
        }}
        // onSelect={onSelect}
        placeholder="Enter address"
      />
    </Form.Item>
  );
}

export default AutoCompleteAddress;
